export default {
  bind:  function () {

  },
  update: function(el, binding ) {
    let input = el;
    if (
      el.nodeName &&
      el.nodeName.toLocaleUpperCase() != "TEXTAREA" &&
      el.nodeName.toLocaleUpperCase() != "INPUT"
    ) {
      input = el.querySelector("input,textarea");
    }
    let inputValue = input.value, newValue = inputValue, flag = "";
    if (!inputValue) {   //当值为空的时候，不做校验
      return;
    } 
    if (!binding.modifiers.number) { // 判断修饰对象是否式number
      return;
    }

    let obj = binding.value; // 绑定值

    if (binding.modifiers.minus || (obj.max && obj.max<0)) {  // 支持负数
      if (newValue == "-" || newValue == "-0" || newValue == "-0.") {
        return;
      } 
      if (newValue < 0) {
        flag = "-";
      }
    }
    newValue = newValue.replace(/[^\d.]/g,"");
    
    if (obj.max) {   // 最大值
      let max = parseFloat(obj.max);
      max = Math.abs(max);
      if (max < newValue) {
        newValue = max.toString();
      }
    }
    if (obj.min) {   // 最小值
      let min = parseFloat(obj.min);
      if (min > newValue) {
        newValue = min.toString();
      }
    }
    
    if (obj.num) {  // 小数
      let value = parseInt(obj.num);
      newValue = /^\./g.test(newValue)? "" : newValue;
      let req = new RegExp("^(\\.*)(\\d+)(\\.?)(\\d{0,"+value+"}).*$", "g");
      newValue = newValue.replace(req, '$2$3$4')
    } else {  // 整数
      newValue = newValue.replace(/[^\d]+/g, "");
    }
    
    newValue = flag? (flag + newValue) : newValue;

    if (obj.max && obj.max<0 && !flag ) {
      newValue = "0";
    }

    if (inputValue !== newValue) {
      input.value = newValue;
      let event = document.createEvent("HTMLEvents")
      event.initEvent("input", false, true);
      input.dispatchEvent(event);
    }
  },
  unbind: function () { }
}